import styled, { keyframes } from "styled-components";

// Animations
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const float = keyframes`
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-5px); }
`;
// Order Modal Styles
export const OrderDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const OrderDetailCard = styled.div`
  background: rgba(255, 107, 53, 0.1);
  border: 1px solid rgba(255, 107, 53, 0.3);
  border-radius: 8px;
  padding: 1rem;
`;

export const OrderDetailLabel = styled.div`
  color: #ff6b35;
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const OrderDetailValue = styled.div`
  color: #ffffff;
  font-size: 1rem;
`;

export const OrderItemsSection = styled.div`
  margin-bottom: 2rem;

  h4 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }
`;

export const OrderItemCard = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #333;
`;

export const OrderItemImage = styled.div`
  width: 60px;
  height: 60px;
  background: #333;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff6b35;
`;

export const OrderItemInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
`;

export const OrderItemName = styled.div`
  color: #ffffff;
  font-weight: bold;
  font-size: 1rem;
`;

export const OrderItemSize = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const OrderItemQuantity = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const OrderItemPrice = styled.div`
  text-align: right;
  color: #cccccc;
  font-size: 0.9rem;

  strong {
    color: #27ae60;
    font-size: 1rem;
  }
`;

export const CustomerInfoSection = styled.div`
  margin-bottom: 2rem;

  h4 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }
`;

export const CustomerInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
`;

export const OrderSummarySection = styled.div`
  margin-bottom: 1rem;

  h4 {
    color: #ff6b35;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }
`;

export const OrderSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
`;
// Styled Components
export const Container = styled.div`
  min-height: 100vh;
  background: #2c2c2c;
  position: relative;
`;

export const Header = styled.header`
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
  padding: 1.5rem 2rem;
  border-bottom: 2px solid #ff6b35;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  position: relative;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const Logo = styled.a`
  font-size: 1.8rem;
  font-weight: bold;
  color: #ff6b35;
  text-decoration: none;
  letter-spacing: 2px;
  cursor: pointer;
`;

export const BandInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BandName = styled.div`
  font-size: 1.5rem;
  color: #ffffff;
  font-weight: bold;
`;

export const BandSubtitle = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const HeaderNav = styled.nav`
  display: flex;
  gap: 2rem;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

export const NavLink = styled.a`
  color: ${(props) => (props.$active ? "#ff6b35" : "#cccccc")};
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    color: #ff6b35;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: ${(props) => (props.$active ? "100%" : "0")};
    height: 2px;
    background: #ff6b35;
    transition: width 0.3s ease;
  }

  &:hover::after {
    width: 100%;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #cccccc;
`;

export const LogoutBtn = styled.button`
  background: #e74c3c;
  color: #ffffff;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &:hover {
    background: #c0392b;
    transform: translateY(-2px);
  }
`;

export const MainContent = styled.div`
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
  animation: ${fadeIn} 0.6s ease-out;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const PageSection = styled.div`
  display: block;
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #333;
  flex-wrap: wrap;
  gap: 1rem;

  & > div {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const PaginationInfo = styled.span`
  color: #cccccc;
  font-size: 0.9rem;
`;

export const PaginationButton = styled.button`
  background: ${(props) => (props.$active ? "#ff6b35" : "#333")};
  color: ${(props) => (props.$active ? "#ffffff" : "#cccccc")};
  border: 1px solid ${(props) => (props.$active ? "#ff6b35" : "#555")};
  padding: 0.5rem 0.8rem;
  min-width: 40px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: ${(props) => (props.$active ? "bold" : "normal")};
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$active ? "#e55a2b" : "#444")};
    border-color: ${(props) => (props.$active ? "#e55a2b" : "#666")};
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: #333;
    border-color: #555;
    color: #666;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;
export const StatCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #444;
  transition: transform 0.3s ease;
  position: relative;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease-out;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b);
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(255, 107, 53, 0.2);
  }
`;

export const StatIcon = styled.div`
  font-size: 2.5rem;
  color: #ff6b35;
  margin-bottom: 1rem;
  animation: ${float} 3s ease-in-out infinite;
`;

export const StatValue = styled.div`
  font-size: 2rem;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  margin-top: ${(props) => (props.$eur ? "-10px" : "0px")};
`;

export const StatChange = styled.div`
  font-size: 0.8rem;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-weight: bold;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;

  &.positive {
    background: rgba(39, 174, 96, 0.2);
    color: #27ae60;
  }

  &.negative {
    background: rgba(231, 76, 60, 0.2);
    color: #e74c3c;
  }
`;

export const ChartsGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ChartContainer = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #333;
  animation: ${fadeIn} 0.8s ease-out;
  position: relative;
`;

export const ChartTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ChartPlaceholder = styled.div`
  height: 300px;
  background: linear-gradient(45deg, #333, #444);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 1rem;
  position: relative;
`;

export const TableContainer = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #444;
  overflow-x: auto;
  transition: all 0.3s ease;

  &:hover {
    border-color: #ff6b35;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const TableTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.8rem;
  font-weight: bold;
`;

export const TableActions = styled.div`
  display: flex;
  gap: 1rem;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    min-width: 10rem;
    white-space: nowrap;
  }
`;

export const TableCell = styled.td`
  padding: 1rem;
  text-align: center;
  border-bottom: 1px solid #333;
  color: #cccccc;
  font-size: 0.9rem;

  &:first-child {
    text-align: left;
    font-weight: 500;
  }

  &:last-child {
    text-align: right;
  }
`;

export const TableRow = styled.tr`
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 107, 53, 0.05);
    transform: translateX(2px);
  }

  &:last-child td {
    border-bottom: none;
  }
`;

export const TableTh = styled.th`
  padding: 1rem;
  text-align: center;
  border-bottom: 2px solid #444;
  color: #ff6b35;
  font-weight: bold;
  background: rgba(255, 107, 53, 0.1);
  font-size: 0.9rem;

  &:last-child {
    text-align: right;
  }

  &:first-child {
    text-align: left;
  }
`;
export const ProductsGrid = styled.div`
  column-width: 320px;
  margin-top: 1.5rem;
  columns: 4;
  column-gap: 1.5rem;

  @media (max-width: 1700px) {
    columns: 3;
  }
  @media (max-width: 1200px) {
    columns: 2;
  }
  @media (max-width: 768px) {
    column-width: 280px;
  }

  @media (max-width: 480px) {
    column-width: 100%;
    column-count: 1;
  }
`;

export const ProductStatus = styled.span`
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  width: fit-content;

  &.active {
    background: rgba(39, 174, 96, 0.2);
    color: #27ae60;
  }

  &.low {
    background: rgba(243, 156, 18, 0.2);
    color: #f39c12;
  }

  &.out {
    background: rgba(231, 76, 60, 0.2);
    color: #e74c3c;
  }
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const ProductInfoRow = styled.div`
  display: flex;
  justify-content: space-between;

  color: #cccccc;
  font-size: 0.9rem;
`;

export const Btn = styled.button`
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.9rem;

  &.primary {
    background: #ff6b35;
    color: #ffffff;

    &:hover {
      background: #e55a2b;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(255, 107, 53, 0.3);
    }
  }

  &.secondary {
    background: #666;
    color: #ffffff;

    &:hover {
      background: #555;
    }
  }

  &.success {
    background: #27ae60;
    color: #ffffff;

    &:hover {
      background: #229954;
    }
  }

  &.warning {
    background: #f39c12;
    color: #ffffff;

    &:hover {
      background: #e67e22;
    }
  }

  &.sm {
    padding: 0.4rem 0.8rem;
    padding: 0.6rem 1.2rem;
    font-size: 0.8rem;
    font-size: 0.9rem;
  }
`;

export const QuickActions = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #2c2c2c 100%);
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #333;
  margin-bottom: 2rem;
  animation: ${fadeIn} 0.4s ease-out;
`;

export const QuickActionsTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const QuickActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const QuickAction = styled.div`
  background: rgba(255, 107, 53, 0.1);
  border: 1px solid rgba(255, 107, 53, 0.3);
  border-radius: 10px;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #ffffff;

  &:hover {
    background: rgba(255, 107, 53, 0.2);
    transform: translateY(-3px);
  }
`;

export const QuickActionIcon = styled.div`
  font-size: 2rem;
  color: #ff6b35;
  margin-bottom: 0.5rem;
`;

export const QuickActionLabel = styled.div`
  font-weight: bold;
`;

export const Modal = styled.div`
  display: ${(props) => (props.$active ? "flex" : "none")};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  backdrop-filter: blur(5px);
  align-items: center;
  justify-content: center;
  animation: ${(props) => (props.$active ? fadeIn : "none")} 0.3s ease-out;
`;

export const ModalContent = styled.div`
  background: #1a1a1a;
  border-radius: 15px;
  padding: 2rem;
  position: relative;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  border: 2px solid #ff6b35;
  animation: ${slideIn} 0.3s ease-out;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const ModalTitle = styled.h3`
  color: #ff6b35;
  font-size: 1.5rem;
  font-weight: bold;
`;

export const CloseBtn = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: #fff;
  border-radius: 50%;
  font-size: 1rem;
  width: 2rem;
  height: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  -webkit-backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
  transition: background 0.3s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #ff6b35;
  }
`;
export const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

export const FormLabel = styled.label`
  display: block;
  color: #ff6b35;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 0.8rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 8px;
  color: #ffffff;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 0.8rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 8px;
  color: #ffffff;
  transition: border-color 0.3s ease;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;
export const Relative = styled.div`
  position: relative;
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  padding: 0.8rem;
  background: #333;
  border: 1px solid #555;
  border-radius: 8px;
  color: #ffffff;
  transition: border-color 0.3s ease;
  resize: vertical;
  min-height: 100px;

  &:focus {
    outline: none;
    border-color: #ff6b35;
  }
`;

export const OrderStatus = styled.button`
  padding: 0.3rem 0.8rem;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: bold;
  border: none;

  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;

  color: ${(props) => {
    switch (props.$status) {
      case "delivered":
      case "active":
        return "#27ae60";
      case "processing":
        return "#f39c12";
      case "inactive":
      case "canceled":
        return "#e74c3c";
      case "shipped":
        return "#3498db";
      case "pending":
        return "#f39c12";
      default:
        return "#cccccc";
    }
  }};
  background: ${(props) => {
    switch (props.$status) {
      case "delivered":
      case "active":
        return "rgba(39, 174, 96, 0.2)";
      case "processing":
      case "pending":
        return "rgba(243, 156, 18, 0.2)";
      case "inactive":
      case "canceled":
        return "rgba(231, 76, 60, 0.2)";
      case "shipped":
        return "rgba(52, 152, 219, 0.2)";
      default:
        return "rgba(204, 204, 204, 0.2)";
    }
  }};

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #666;
`;

export const EmptyStateIcon = styled.div`
  font-size: 4rem;
  color: #444;
  margin-bottom: 1rem;
`;

export const EmptyStateTitle = styled.h4`
  color: #cccccc;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;

export const EmptyStateText = styled.p`
  color: #666;
  margin-bottom: 2rem;
`;

export const ProductGrid = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;
export const LoadingContainer = styled.div`
  text-align: center;
  padding: 2rem;
  color: #cccccc;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: center;
  gap: 10px;
  flex-direction: column;
`;

export const ProductCard = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 15px;
  padding: 1.5rem;
  border: 1px solid #444;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  animation: ${fadeIn} 0.6s ease-out;
  break-inside: avoid;
  width: 100%;
  margin-bottom: 1.5rem;
  max-width: 350px;
  display: flex;
  flex-direction: column;
  height: fit-content;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, #ff6b35, #e55a2b);
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(255, 107, 53, 0.3);
    border-color: #ff6b35;
  }
`;

export const ProductImageContainer = styled.div`
  width: 100%;
  height: 200px;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 1rem;
  background: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const Badge = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: ${({ $variant }) =>
    $variant === "discount"
      ? "#e74c3c"
      : $variant === "limited"
      ? "#9b59b6"
      : $variant === "novo"
      ? "#27ae60"
      : "#ff6b35"};
  color: #ffffff;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  z-index: 10;
`;

export const ProductHeader = styled.div`
  margin-bottom: 1rem;
`;

export const ProductTitle = styled.h4`
  color: #ffffff;
  font-size: 1.1rem;
  font-weight: bold;
  margin: 0 0 0.5rem 0;
  line-height: 1.3;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  word-break: break-word;
  white-space: normal;
`;

export const ProductBand = styled.span`
  color: #ff6b35;
  font-size: 0.9rem;
  font-weight: 600;
`;

export const ProductMeta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
`;

export const ProductMetaItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ProductCategory = styled.span`
  background: rgba(255, 107, 53, 0.2);
  color: #ff6b35;
  padding: 0.3rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const ProductPrice = styled.span`
  color: ${(props) => (props.$discounted ? "#888" : "#27ae60")};
  font-weight: bold;
  font-size: ${(props) => (props.$discounted ? "0.9rem" : "1.1rem")};
  text-decoration: ${(props) => (props.$discounted ? "line-through" : "none")};
`;

export const ProductDiscountPrice = styled.span`
  color: #27ae60;
  font-weight: bold;
  font-size: 1.1rem;
`;

export const StockInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
`;

export const StockBadge = styled.span`
  background: ${(props) =>
    props.$inStock ? "rgba(39, 174, 96, 0.2)" : "rgba(231, 76, 60, 0.2)"};
  color: ${(props) => (props.$inStock ? "#27ae60" : "#e74c3c")};
  padding: 0.3rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
`;

export const ProductSizes = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
`;

export const ProductShortDesc = styled.p`
  color: #cccccc;
  font-size: 0.9rem;
  line-height: 1.4;
  margin: 0 0 1.5rem 0;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  word-break: break-word;
  white-space: normal;
`;

export const SizeStockDisplay = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
`;

export const SizeStockTitle = styled.div`
  color: #cccccc;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export const SizeStockList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const SizeStockBadge = styled.span`
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: bold;
  color: ${(props) => {
    switch (props.$alertLevel) {
      case "critical":
        return "#c0392b"; // Red text
      case "warning":
        return "#e67e22"; // Orange text
      default:
        return "#229954"; // Green text
    }
  }};
  background: ${(props) => {
    switch (props.$alertLevel) {
      case "critical":
        return "#e74c3c25"; // Red background
      case "warning":
        return "#f39c1225"; // Orange background
      default:
        return "#27ae6025"; // Green background
    }
  }};
  border: 1px solid
    ${(props) => {
      switch (props.$alertLevel) {
        case "critical":
          return "#c0392b"; // Red border
        case "warning":
          return "#e67e22"; // Orange border
        default:
          return "#229954"; // Green border
      }
    }};
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

export const AnalyticsInfo = styled.div`
  background: rgba(255, 107, 53, 0.1);
  border: 1px solid rgba(255, 107, 53, 0.3);
  border-radius: 8px;
  padding: 0.8rem;
  margin-bottom: 1rem;
`;

export const AnalyticsTitle = styled.div`
  color: #ff6b35;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

export const AnalyticsStats = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  font-size: 0.8rem;
`;

export const AnalyticsStat = styled.div`
  color: #cccccc;

  span {
    color: #ffffff;
    font-weight: bold;
  }
`;

export const ProductActions = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  flex-wrap: wrap;
`;

export const Button = styled.button`
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-size: 0.9rem;

  background: ${(props) => {
    switch (props.$variant) {
      case "primary":
        return "#ff6b35";
      case "secondary":
        return "#666";
      case "danger":
        return "#e74c3c";
      case "success":
        return "#27ae60";
      default:
        return "#ff6b35";
    }
  }};
  color: #ffffff;

  &:hover {
    background: ${(props) => {
      switch (props.$variant) {
        case "primary":
          return "#e55a2b";
        case "secondary":
          return "#555";
        case "danger":
          return "#c0392b";
        case "success":
          return "#229954";
        default:
          return "#e55a2b";
      }
    }};
    transform: translateY(-2px);
  }
`;

// Chart lock overlay components
export const ChartLockOverlay = styled.div`
  position: relative;
  height: 300px;
`;

export const ChartBlur = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(8px);
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  z-index: 2;
`;

export const ChartLockIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #ff6b35;

  svg {
    font-size: 3rem;
    animation: ${float} 2s ease-in-out infinite;
  }

  .lock-text {
    font-size: 1.1rem;
    font-weight: 600;
    text-align: center;
    color: #ffffff;

    .highlight {
      color: #ff6b35;
      font-weight: bold;
    }
  }
`;

export const ChartBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 10px;
  z-index: 1;
`;

// Mobile responsive header components
export const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #ff6b35;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 107, 53, 0.1);
    transform: scale(1.1);
  }

  @media (max-width: 1200px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const MobileMenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  z-index: 1000;
  display: ${(props) => (props.$isOpen ? "flex" : "none")};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  animation: ${(props) => (props.$isOpen ? "fadeIn" : "fadeOut")} 0.3s
    ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;

export const MobileMenuContent = styled.div`
  background: linear-gradient(135deg, #1a1a1a 0%, #333 100%);
  border-radius: 20px;
  padding: 2rem;
  width: 90%;
  max-width: 400px;
  border: 1px solid #444;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  animation: slideIn 0.4s ease-out;

  @keyframes slideIn {
    from {
      transform: translateY(-50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #444;
`;

export const MobileMenuLogo = styled.h2`
  color: #ff6b35;
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0;
`;

export const MobileMenuClose = styled.button`
  background: none;
  border: none;
  color: #cccccc;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #ff6b35;
    background: rgba(255, 107, 53, 0.1);
    transform: rotate(90deg);
  }
`;

export const MobileMenuNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const MobileNavLink = styled.button`
  background: ${(props) =>
    props.$active ? "rgba(255, 107, 53, 0.2)" : "transparent"};
  border: 1px solid ${(props) => (props.$active ? "#ff6b35" : "transparent")};
  color: ${(props) => (props.$active ? "#ff6b35" : "#cccccc")};
  padding: 1rem 1.5rem;
  border-radius: 12px;
  text-align: left;
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 107, 53, 0.1);
    color: #ff6b35;
    border-color: #ff6b35;
    transform: translateX(10px);
  }
`;

export const MobileMenuUser = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 107, 53, 0.1);
  border-radius: 12px;
  border: 1px solid rgba(255, 107, 53, 0.3);
  margin-bottom: 1rem;
  position: relative;
`;

export const Username = styled.span`
  color: #cccccc;
  font-size: 1rem;
  font-size: ${(props) => (props.$mail ? "0.8rem" : "1rem")};
  margin-top: ${(props) => (props.$mail ? "-4px" : "0px")};
`;

export const NameContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const MobileMenuLogout = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  border: none;
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #c0392b, #a93226);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(231, 76, 60, 0.3);
  }
`;

// Update existing Header component to be responsive
export const HeaderNavWrapper = styled.div`
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const HeaderActionsWrapper = styled.div`
  @media (max-width: 1200px) {
    display: none;
  }
`;
